import {
  GET_LIST_DANHSACHCUAHANG,
  GET_LIST_DANHSACHCUAHANG_SUCCESS,
  GET_LIST_DANHSACHCUAHANG_FAILURE,
} from "actions/DanhSachCuaHang/actionTypes";
const initialState = {
  List: [],
  TongBanGhi: 0,
  getListDanhSachCuaHangLoading: false,
};

const getDanhSachCuaHang = (state, action) => ({
  ...state,
  getListDanhSachCuaHangLoading: true,
});

const getDanhSachCuaHangSuccess = (state, action) => {
  return {
    ...state,
    List: action.payload.List,
    TongBanGhi: action.payload.TongBanGhi,
    getListDanhSachCuaHangLoading: false,
  };
};

const getDanhSachCuaHangFailed = (state, action) => ({
  ...state,
  getListDanhSachCuaHangLoading: false,
  List: [],
});

const listCuaHangReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_LIST_DANHSACHCUAHANG:
      return getDanhSachCuaHang(state, action);
    case GET_LIST_DANHSACHCUAHANG_SUCCESS:
      return getDanhSachCuaHangSuccess(state, action);
    case GET_LIST_DANHSACHCUAHANG_FAILURE:
      return getDanhSachCuaHangFailed(state, action);
    default:
      return state;
  }
};

export default listCuaHangReducer;
